import { useContext } from 'react';
import { getEntityFromScope } from '@bingads-webui/edm-campaign';
import { useObservable } from '@bingads-webui-react/use-observable';
import { ScopeContext } from '@bingads-webui-react/scope-service';

function useGivenEntity(select, edmInstance) {
  const observable = edmInstance ? edmInstance.get({ select }) : null;
  const state = useObservable(observable);

  return state.data;
}

const campaignDefaultSelect = [
  'Id',
  'Name',
  'Status',
  'CampaignType',
  'Budget',
  'BiddingScheme',
  'ExperimentId',
];

export function useCurrentCampaign(select = campaignDefaultSelect) {
  const ctx = useContext(ScopeContext);
  const { currentCampaign } = getEntityFromScope(ctx.scope);

  return useGivenEntity(select, currentCampaign);
}

const adGroupDefaultSelect = [
  'Id',
  'Name',
  'Status',
  'EntityStatus',
  'SearchBid',
  'BiddingScheme',
];

export function useCurrentAdGroup(select = adGroupDefaultSelect) {
  const ctx = useContext(ScopeContext);
  const { currentAdGroup } = getEntityFromScope(ctx.scope);

  return useGivenEntity(select, currentAdGroup);
}
